import Icon, { SearchOutlined } from "@ant-design/icons";
import React from "react"
import styled from "styled-components";
import { COLORS } from "../../constants/colors";
import allIcons from "../../constants/svgIcon";

interface Props {
    placeholder: string;
    active: boolean;
    props: any;
    onChange: any;
    name: string;
    borderColor: string;
    textColor: string;
    backgroundcolor?: string;
    placeholdercolor?: string;
    opacity?: number;
    value?: string;
}


const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    flex-direction: 'row';
    opacity: ${(props) => !!props.opacity ? props.opacity : 1};
    background-color: ${(props) => props.backgroundcolor};
    border-radius: 5px;
    border: .2px solid ${(props) => props.borderColor};
     
    input{
        background-color: ${COLORS.transparent_color1} !important;
        border: none;
        opacity: 1;
        outline: none !important;
        width: 100%;
        padding-left: 10px;
        height: 40px;
        font-size: 1.07em;
        font-weight: 300;
        color: ${(props) => props.textColor} !important;
        transition: all .5s;
        ${(props) => props.collapsed === 'true' && (`
             display: none;
        `
    )}
    }


     input::placeholder {
        color: ${(props) => props.placeholdercolor};
        font-weight: 300;
        font-size: 1.07em;
        opacity: 0.7;
    }
    
    .icon {
        color: ${(props) => props.placeholdercolor};
        font-size: 1.5em;
        margin-left: 10px;
        opacity: 0.5;
        transition: all .05s;
        
        
    }

    ${(props) => props.collapsed === 'true' && (`
             .icon {
                margin-left: 0px;
                cursor: pointer;
            }
            height: 37px;
            justify-content: center;
            align-items: center;
    `
    )}

    `;

const SearchText: React.FC<Props> = ({ placeholder, active, onChange, name, value, borderColor, textColor, props, opacity, backgroundcolor, placeholdercolor }) => {

    return (
        <InputWrapper borderColor={borderColor} textColor={textColor} placeholdercolor={placeholdercolor} opacity={opacity} backgroundcolor={backgroundcolor} active={active} value={value} collapsed={props.collapsed}>
            <nav className="icon">{<SearchOutlined />}</nav>
            <input name={name} onChange={(e) => onChange(e.target.value)} disabled={active ? false : true} value={value} className="input" placeholder={placeholder} />
        </InputWrapper>
    )
}

export default SearchText;